// extracted by mini-css-extract-plugin
module.exports = {"loading-icon":"loading-icon_loading-icon__YkV9N","loading-icon--dark":"loading-icon_loading-icon--dark__8RZ27"};